import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { CaretDown } from 'phosphor-react'
import { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'

export const LoginDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)

  const dropdownRef = useRef(null)

  useOnClickOutside(dropdownRef, () => {
    setTimeout(() => {
      setIsOpen(false)
    }, 200)
  })

  return (
    <DropdownMenu.Root modal={false} open={isOpen}>
      <DropdownMenu.Trigger asChild ref={dropdownRef}>
        <button
          type="button"
          className="flex items-center gap-1 font-semibold uppercase outline-none"
          onClick={() => setIsOpen(true)}
        >
          Login
          <CaretDown />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="flex flex-col pt-[30px] overflow-hidden bg-[#001D2F] rounded-b-lg">
          <Link
            to="/expert"
            target='_blank'
            className="block py-2 px-2.5 font-semibold text-white text-left hover:bg-[#4A7D9A]"
          >
            Expert
          </Link>
          <Link
            to="/painel"
            target='_blank'
            className="block py-2 px-2.5 font-semibold text-white text-left hover:bg-[#4A7D9A]"
          >
            Admin
          </Link>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
